import Vue from 'vue'
import Router from 'vue-router'
import AdminStart from '@/views/admin/Start.vue'
import Distribution from '@/views/admin/Distribution.vue'
import Messages from '@/views/admin/Message.vue'
import Bundles from '@/views/admin/Bundles.vue'
import DailyProduct from '@/views/admin/DailyProductUpload.vue'
import Holidays from '@/views/admin/Holidays.vue'
import Products from '@/views/admin/Products.vue'
import Invoice from '@/views/admin/Invoice.vue'
import Guarantees from '../views/admin/Guarantees.vue'
import MiniDeb from '@/views/admin/MiniDeb.vue'

import store from '@/store'
import { userHasRole } from '@/model/roles'
import { SET_USER } from '@/store/appMutations'
import { setAuthHeader } from '@/backend/axios'
import AdminLayout from '@/layouts/AdminLayout.vue'
// import * as rs from '@/model/reportState'
 import settings from '@/model/settings'
import log from '@/logger'
Vue.use(Router)

// hooks
// beforeRouteUpdate (to, from, next) {
//   // react to route changes...
//   // don't forget to call next()
//   console.log('Route:', to, from, next)
// }


const routes = [ 
  {
    path: '/',
    name: 'root',
    component: AdminStart,
    meta: {
       layout: AdminLayout,
      requiresAuth: true,
      roles: ['admin','sales']
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminStart,
    meta: { 
      title:'Admin',
      layout: AdminLayout,
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
    path: '/distribution',
    name: 'distribution',
    component: Distribution,
    meta: { 
      title:'Distribution',
      layout: AdminLayout,
      requiresAuth: true,
       roles: ['admin', 'sales', 'utb']
    }
  },
  {
    path: '/messages',
    name: 'messages',
    component: Messages,
    meta: { 
      title:'Meddelanden',
      layout: AdminLayout,
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
    path: '/dailyproducts',
    name: 'dailyproducts',
    component: DailyProduct,
    meta: { 
      title:'Dagens produkter',
      layout: AdminLayout,
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
    path: '/bundles',
    name: 'bundles',
    component: Bundles,
    meta: { 
      title:'Buntar',
      layout: AdminLayout,
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
    path: '/kundtjanst',
    name: 'kundtjanst',
    component: AdminStart,
    meta: { 
      title:'Kundtjänst',
      layout: AdminLayout,
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
      path: '/holidays',
      name: 'holidays',
      component: Holidays,
      meta: { 
        title:'Helgspärr',
        layout: AdminLayout,
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
      meta: { 
        title:'Produkt Information',
        layout: AdminLayout,
        requiresAuth: true,
        roles: ['admin']
      }
    },        
    {
      path: '/invoice',
      name: 'invoice',
      component: Invoice,
      meta: { 
        title:'Fakturering',
        layout: AdminLayout,
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/guarantees',
      name: 'guarantees',
      component: Guarantees,
      meta: { 
        title:'Garantibelopp',
        layout: AdminLayout,
        requiresAuth: true,
        roles: ['admin']
      }
    },
    {
      path: '/minideb',
      name: 'minideb',
      component: MiniDeb,
      meta: { 
        title:'MiniDeb',
        layout: AdminLayout,
        requiresAuth: true,
        roles: ['admin']
      }
    },  
  {
    path: '/start',
    name:'start',
    beforeEnter() {
        window.location.href = settings.route.www//'https://www-dev.kvallstidningarna.se/'
    },
    component: AdminStart,
     meta: { layout: AdminLayout }
  },  
  {
    path:'/login',
    name:'login',
    // component: WebStart,
    //  meta: { layout: WebLayout }
   beforeEnter(){
      window.location.href =  settings.route.www+'/behorighet-saknas/'//'https://www-dev.kvallstidningarna.se/behorighet-saknas/'
    }  
  },
  {
    path:'/logout',
    name:'logout',
    beforeEnter(){
      window.location.href = settings.route.www+'/logout' //'https://www-dev.kvallstidningarna.se/logout/'
    }  
  }
  
]

let router = new Router({
  mode: 'history',  
  routes
})

router.beforeEach((to, from, next) => {
  log.debug('Navigating to:', to.name, 'from:', from.name)
 
  // if( to.name !== 'logout'){
  //   next()
  // }
  // if(to.matched.some(record => record.meta.requiresAuth)) {          
  //   if(store.getters.user !== undefined){      
  //     const user = store.getters.user
  //     if (!to.matched.every(record => userHasRole(user, record.meta.roles))) {
  //        return next({ name: 'login' })
  //     }
  //     next({
  //       path: '/',
  //       params: { nextUrl: to.fullPath }
  //     })
  //   }else{
  //     return next({ name: 'login' })
  //   }
    
  //   // const token = Vue.$cookies.isKey('auth_token')        
  //   // if (!token ) {
  //   //     next({
  //   //         path: '/login',
  //   //         params: { nextUrl: to.fullPath }
  //   //     })
  //   //   } else {       
  //   //     next()          
  //   //   } 
  // }else {
  //     next()
  // }
  if (to.name === 'logout') {
    return next()
  }

  const user = store.getters.user
  log.debug('User:', user)
  const loggedIn = !!(user && user.token)
  if (!loggedIn) {
    // Logged-out users stay on root, which shows the login box.
    if (to.name === 'root' || !to.matched.some(record => record.meta.requiresAuth)) {
      return next()
    }
    return next({ name: 'root' })
  }

  log.debug('Check role:')
  if (!to.matched.every(record => userHasRole(user, record.meta.roles))) {
    if (settings.env === 'development') {
      // Dev has no www login; drop the session so root shows the admin login box.
      setAuthHeader(null)
      store.commit(SET_USER, {})
      return next({ name: 'root' })
    }
    return next({ name: 'login' })
  }

  next()
})

export default router

